module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"api-key":"API Key","api-password":"API Password","auth-code":"Auth Code","payment-method":"Payment Method","reference":"Reference","create-carrier":"Create Carrier","update-carrier":"Update Carrier","failed-authorise":"Authorisation failed, please try again.","trading-name":"Trading Name"}}')
  delete Component.options._Ctor
}
